/**
 * Gestion dynamique de la mention de précommande dans le panier
 * Met à jour la visibilité de l'avertissement global quand le panier change
 * Compatible avec cart-drawer et main-cart-items
 */

class PreorderCartNotice {
  constructor() {
    this.debouncedUpdate = this.debounce(() => this.updateAllNotices(), 150);
    this.init();
  }

  // Fonction debounce pour éviter les appels multiples
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  init() {
    // Écouter les mises à jour du panier (pubsub de Dawn)
    if (typeof subscribe === 'function' && PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        // Synchroniser la mise à jour avec le rendu du DOM plutôt qu'un délai arbitraire
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(() => this.updateAllNotices());
        } else {
          this.updateAllNotices();
        }
      });
    }

    // Observer les changements dans le DOM du panier principal
    this.observeCartChanges('main-cart-items');

    // Observer les changements dans le cart-drawer
    this.observeCartChanges('CartDrawer-CartItems');

    // Vérifier l'état initial
    this.updateAllNotices();
  }

  observeCartChanges(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const observer = new MutationObserver(() => {
      // Utiliser la version debounced pour éviter les appels multiples
      this.debouncedUpdate();
    });

    observer.observe(container, {
      childList: true,
      subtree: true  // Observer aussi les sous-éléments pour capter tous les changements d'articles
    });
  }

  hasPreorderItems(container) {
    // Vérifier si des éléments avec la classe preorder-info existent dans le conteneur
    const preorderItems = container.querySelectorAll('.cart-item__preorder-info');
    return preorderItems.length > 0;
  }

  updateNotice(noticeSelector, containerSelector) {
    const notice = document.querySelector(noticeSelector);
    if (!notice) return;

    const container = document.querySelector(containerSelector);
    if (!container) return;

    const hasPreorder = this.hasPreorderItems(container);

    if (hasPreorder) {
      notice.style.display = 'block';
    } else {
      notice.style.display = 'none';
    }
  }

  updateAllNotices() {
    // Mettre à jour la notice du panier principal
    this.updateNotice('.cart__preorder-notice', '#main-cart-items');

    // Mettre à jour la notice du cart-drawer
    this.updateNotice('.cart-drawer__preorder-notice', '#CartDrawer-CartItems');
  }
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PreorderCartNotice();
  });
} else {
  new PreorderCartNotice();
}
